import { DEFAULT_BILLING_CURRENCY_SYMBOL } from '../../../constants/print-store'
import { ProductQuantityItemsProps } from '../../../types/print-store.types'
import { StyledTableRow } from './styles'
import { TableCell } from '@dtx-company/shared-components/src/components/atoms/TableCell/index'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { calculateSavedPercent, calculateStickerPrice } from '../../../utils/print-store'
import { memo } from 'react'

export const ProductQuantityItemsComponent = ({
  tier,
  handleQuantity,
  selectedQuantity,
  minUnitAmount
}: ProductQuantityItemsProps): JSX.Element => {
  const savedValue = calculateSavedPercent(minUnitAmount, tier?.quantity, tier?.unitAmount)
  const isActive = tier?.quantity === selectedQuantity

  return (
    <StyledTableRow
      base="tbody"
      backgroundColor={isActive ? 'secondary.backgroundDark' : 'primary.white'}
      onClick={() => handleQuantity(tier?.quantity, savedValue)}
      aria-label={`quantity-${tier?.quantity}`}
    >
      <TableCell padding="16px 16px 16px 12px">
        <Text variant="body/medium" lineHeight="18px">
          {tier?.quantity}
        </Text>
      </TableCell>
      <TableCell padding="16px 0">
        <Text variant="body/medium" lineHeight="18px">
          {DEFAULT_BILLING_CURRENCY_SYMBOL +
            calculateStickerPrice(tier?.quantity, tier?.unitAmount)}
        </Text>
      </TableCell>
      <TableCell padding="16px">
        {Boolean(savedValue) && (
          <Text
            variant="body/small"
            color="masterWeb.grey6"
            minWidth="64px"
            textAlign="right"
          >{`Save ${savedValue}%`}</Text>
        )}
      </TableCell>
    </StyledTableRow>
  )
}

export const ProductQuantityItems = memo(ProductQuantityItemsComponent)
